"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainDefectSortColumn = void 0;
var TrainDefectSortColumn;
(function (TrainDefectSortColumn) {
    TrainDefectSortColumn["Position"] = "Position";
    TrainDefectSortColumn["Date"] = "Date";
    TrainDefectSortColumn["DefectName"] = "DefectName";
    TrainDefectSortColumn["Rate"] = "Rate";
    TrainDefectSortColumn["CreationType"] = "CreationType";
    TrainDefectSortColumn["DefectStatus"] = "DefectStatus";
})(TrainDefectSortColumn || (exports.TrainDefectSortColumn = TrainDefectSortColumn = {}));
//# sourceMappingURL=sort.js.map